import { TDispatchFormInfoParams, TFormInfo } from '@/modules/pricing/hooks';
import usePlansData, { PlanUnitPriceInfoV2 } from '@/modules/pricing/hooks/usePlansData';
import { GOODS_TYPE, PlanDataType } from '@/modules/pricing/utils';
import React, { Dispatch, createContext } from 'react';

interface IPricingContext {
  lang: 'en' | 'ja';
  teamPlanUnitPriceInfo: PlanUnitPriceInfoV2;
  planInfo: PlanDataType[];
  formInfo: TFormInfo;
  dispatchFormInfo: Dispatch<TDispatchFormInfoParams>;
  getUpgradeLink: (type: GOODS_TYPE) => string;
}

interface IProps {
  lang: 'en' | 'ja';
  children?: any;
}

export const PricingContext = createContext<IPricingContext>({
  lang: 'ja',
  teamPlanUnitPriceInfo: null,
  planInfo: null,
  dispatchFormInfo: null,
  formInfo: null,
  getUpgradeLink: null,
});

const PricingProvider = ({ lang, children }: IProps) => {
  const { planInfo, dispatchFormInfo, formInfo, getUpgradeLink, teamPlanUnitPriceInfo } = usePlansData({ lang });

  return (
    <PricingContext.Provider
      value={{
        lang,
        teamPlanUnitPriceInfo,
        planInfo,
        formInfo,
        dispatchFormInfo,
        getUpgradeLink,
      }}
    >
      {children}
    </PricingContext.Provider>
  );
};

export default PricingProvider;
